import React, {useEffect, useState} from "react";
import {Controller, useForm} from 'react-hook-form';
import Loading from "../components/Loading";
import {PageLoader} from "../components/PageLoader";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import UserService from "../services/UserService";
import {toast, ToastContainer} from "react-toastify";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

import {geocodeByPlaceId} from 'react-google-places-autocomplete';
import {PageLayout} from "./PageLayout";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../config/routes";

const isNumber = (number) => !isNaN(number) || "Must be a number";

export const ProfileDetails = ({ onDataChange, sharedData }) => {

    let navigate = useNavigate();
    const registerOptions = {
        email: {
            required: "Email is required",
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address"
            }
        },
        city: {
            required: "City is required",
            maxLength: {
                value: 108,
                message: "City cannot be more than 108 characters"
            }
        },
        zip: {
            required: "Zip is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        state: {
            required: "State is required",
            maxLength: {
                value: 50,
                message: "State cannot be more than 50 characters"
            }
        },
        country: {
            required: "Country is required",
            maxLength: {
                value: 50,
                message: "State cannot be more than 50 characters"
            }
        },
        addressLineOne: {
            required: "Address is required",
            maxLength: {
                value: 125,
                message: "Address cannot be more than 125 characters"
            }
        },
        addressLineTwo: {
            maxLength: {
                value: 75,
                message: "Address cannot be more than 75 characters"
            }
        },
        firstName: {
            required: "FirstName is required",
            maxLength: {
                value: 75,
                message: "FirstName cannot be more than 75 characters"
            }
        },
        lastName: {
            required: "Last Name is required",
            maxLength: {
                value: 75,
                message: "Lastname cannot be more than 75 characters"
            }
        }
    };


    const [howDoYouKnowUs, setHowDoYouKnowUs] = useState("1");
    const [userTypes, setUserTypes] = useState([]); // I am a: Carrier, Broker, Shipper, Other (multi-select)

    const onOptionChange = e => {
        setHowDoYouKnowUs(e.target.value)
    }

    const onUserTypeChange = e => {
        const value = e.target.value;
        setUserTypes(prev => {
            if (prev.includes(value)) {
                // Remove if already selected
                return prev.filter(type => type !== value);
            } else {
                // Add if not selected
                return [...prev, value];
            }
        });
    }

    const [value, setValue] = useState(null);
    let reference = React.createRef();

    function friend(value) {
        setValue(value);
        geocodeByPlaceId(value.value.place_id)
            .then(results => {


                //Preparation

                let addressLineOne = '';
                let city = '';
                let state = '';
                let country = '';
                let zip = '';
                let mobileNumber = farelanesUser.mobileNumber;
                let formatted_address = '';

                for (let i = 0; i < results[0].address_components.length; i++) {
                    let types = results[0].address_components[i].types;

                    if (types.includes('street_number')) {
                        addressLineOne = results[0].address_components[i].long_name;
                    }

                    if (types.includes('route')) {
                        addressLineOne = addressLineOne + ' ' + results[0].address_components[i].long_name
                    }

                    if (types.includes('locality')) {
                        city = results[0].address_components[i].long_name
                    }

                    if (types.includes('administrative_area_level_1')) {
                        state = results[0].address_components[i].short_name
                    }

                    if (types.includes('country')) {
                        country = results[0].address_components[i].short_name
                    }
                    if (types.includes('postal_code')) {
                        zip = results[0].address_components[i].short_name;
                    }

                    if (types.includes('postal_code_suffix')) {
                        zip = zip + '-' + results[0].address_components[i].short_name;
                    }
                }

                setFarelanesUser({
                    ...state,
                    addressLineOne: addressLineOne,
                    city: city,
                    state: state,
                    country: country,
                    zipCode: zip,
                    mobileNumber: mobileNumber
                });

            })
            .catch(error => console.error(error));
    }

    const {
        control,
        register,
        reset,
        handleSubmit,
        formState: {errors},
    } = useForm()

    const [state, setState] = useState({
        showResult: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
    });

    const [farelanesUser, setFarelanesUser] = useState(null);

    const {
        getAccessTokenSilently,
        user
    } = useAuth0();

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            UserService.me(token, user).then(
                response => {
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data,
                        farelanesUser: {firstName: 'Frank', lastName: 'Murphy'}
                    });
                    setFarelanesUser({
                        firstName: response.data.firstName,
                        lastName: response.data.lastName,
                        mobileNumber: response.data.mobileNumber || '1',
                        email: response.data.email || user?.email || '',
                        addressLineOne: response.data.addressLineOne,
                        addressLineTwo: response.data.addressLineTwo,
                        state: response.data.state,
                        city: response.data.city,
                        country: response.data.country,
                        zipCode: response.data.zipCode,
                        userTypes: response.data.userTypes || [],
                    });

                    setHowDoYouKnowUs(response.data.howDoYouKnowUs || "1")
                    // Handle both legacy string (userType) and new array (userTypes) format
                    const types = response.data.userTypes || (response.data.userType ? [response.data.userType] : []);
                    setUserTypes(types)
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };

    async function onSubmit(data) {
        // display form data on submit
        const token = await getAccessTokenSilently();
        setState({
            ...state,
            showResult: false
        });

        UserService.putUser({
            firstName: data.firstName,
            lastName: data.lastName,
            mobileNumber: data.mobileNumber,
            email: data.email,
            addressLineOne: data.addressLineOne,
            addressLineTwo: data.addressLineTwo,
            state: data.state,
            city: data.city,
            country: data.country,
            zipCode: data.zipCode,
            sub: user.sub,
            howDoYouKnowUs: howDoYouKnowUs,
            userTypes: userTypes
        }, token).then(response => {
            setState({
                ...state,
                showResult: true
            });
            // Show success toast - matching COMPANY ID styling (white toast)
            const toastId = toast("User profile details update success", {
                autoClose: 3000,
                onClose: () => console.log("Toast closed")
            });
            // Fallback: ensure toast closes after 3 seconds
            setTimeout(() => {
                toast.dismiss(toastId);
            }, 3000);
            // Navigate to Company ID tab after a short delay to show the toast
            setTimeout(() => {
                // Dispatch event to refresh onboarding status without full reload
                window.dispatchEvent(new CustomEvent('onboardingStatusChanged'));
                // Redirect to Company ID tab
                navigate(`${ROUTES.DASHBOARD}?tab=setup&subtab=company`);
            }, 1000);
        }).catch(error => {
            setState({
                ...state,
                showResult: true
            });
            const errorToastId = toast.error("Failed to update profile details", {
                autoClose: 5000,
                onClose: () => console.log("Error toast closed")
            });
            // Fallback: ensure toast closes after 5 seconds
            setTimeout(() => {
                toast.dismiss(errorToastId);
            }, 5000);
        })
        return true;
    }


    // effect runs on component mount
    useEffect(() => {
        // simulate async api call with set timeout
        callApi().then();
    }, []);

    // effect runs when user state is updated
    useEffect(() => {
        // reset form with user data
        reset(farelanesUser);
    }, [farelanesUser]);

    return <section id="my-profile-form" className="my-form">
        <ToastContainer position="top-center"
                        className= "toast-message"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss={false}
                        draggable
                        pauseOnHover={false}
                        theme="light"/>
        {farelanesUser &&
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    {/* Left Column - Main Fields */}
                    <div className="col-md-8">
                        {/* I am a: Section - White Background */}
                        <div className="row mb-4" style={{backgroundColor: '#ffffff', padding: '20px', borderRadius: '8px', marginBottom: '20px'}}>
                            <div className="col-md-12">
                                <label className="form-label" style={{fontSize: '16px', fontWeight: '400', color: '#414042', marginBottom: '12px'}}>
                                    I am a:
                                </label>
                                <div className="d-flex flex-wrap" style={{gap: '20px'}}>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="userTypes"
                                               id="userTypeCarrier" value="Carrier" checked={userTypes.includes('Carrier')}
                                               onChange={onUserTypeChange}/>
                                        <label className="form-check-label" htmlFor="userTypeCarrier">
                                            Carrier
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="userTypes"
                                               id="userTypeBroker" value="Broker" checked={userTypes.includes('Broker')}
                                               onChange={onUserTypeChange}/>
                                        <label className="form-check-label" htmlFor="userTypeBroker">
                                            Broker
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="userTypes"
                                               id="userTypeShipper" value="Shipper" checked={userTypes.includes('Shipper')}
                                               onChange={onUserTypeChange}/>
                                        <label className="form-check-label" htmlFor="userTypeShipper">
                                            Shipper
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="userTypes"
                                               id="userTypeOther" value="Other" checked={userTypes.includes('Other')}
                                               onChange={onUserTypeChange}/>
                                        <label className="form-check-label" htmlFor="userTypeOther">
                                            Other
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Name Section - Grey Background starts here */}
                        <div className="row">

                            <div className="row" style={{backgroundColor: '#f4f4f4', padding: '20px', borderRadius: '8px', marginBottom: '20px'}}>
                                <div className="col-md-12">
                                    <label className="form-label" style={{fontSize: '16px', fontWeight: '400', color: '#414042', marginBottom: '12px'}}>
                                        Name
                                    </label>
                                </div>
                                <div className="col-sm-6 col-md-6 mb-3">
                                    <div className="form-outline">
                                        <input className="form-control my-text-field" id="firstName"
                                               placeholder={"First name*"}
                                               {...register("firstName", registerOptions.firstName)}
                                        />
                                        <small className="text-danger">
                                            {errors?.firstName && errors.firstName.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6 mb-3">
                                    <div className="form-outline">
                                        <input
                                            className="form-control my-text-field" placeholder={"Last name*"}
                                            {...register("lastName", registerOptions.lastName)} />
                                        <small className="text-danger">
                                            {errors?.lastName && errors.lastName.message}
                                        </small>
                                    </div>
                                </div>
                            </div>


                            {/* Address lookup heading (outside yellow background) */}
                            <div className="row mb-2">
                                <div className="col-md-12">
                                    <label
                                        className="form-label"
                                        htmlFor="address-search"
                                        style={{marginBottom: '4px', fontSize: '16px', fontWeight: '500', color: '#414042'}}
                                    >
                                        Address lookup
                                    </label>
                                </div>
                            </div>

                            {/* Address lookup Section - Yellow Background */}
                            <div className="row" style={{backgroundColor: '#FFF9E6', padding: '20px', borderRadius: '8px', marginBottom: '20px'}}>
                                <div className="col-md-12">
                                    <div>
                                        <div className="address-search-wrapper" style={{
                                            border: '2px solid #006838',
                                            borderRadius: '8px',
                                            padding: '2px',
                                            backgroundColor: '#ffffff',
                                            boxShadow: '0 2px 4px rgba(0, 104, 56, 0.1)'
                                        }}>
                                            <GooglePlacesAutocomplete
                                                placeholder='Start typing an address'
                                                apiKey="AIzaSyDaLZOaYvwAJGsem6pjU8Vg80he7vi2uf0"
                                                selectProps={{
                                                    value,
                                                    onChange: friend,
                                                    styles: {
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            border: 'none',
                                                            boxShadow: 'none',
                                                            minHeight: 'auto',
                                                            height: 'auto',
                                                            '&:hover': {
                                                                border: 'none',
                                                            },
                                                            fontSize: '20px',
                                                            fontWeight: '300',
                                                            padding: '0.32rem 0.75rem',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#666',
                                                            opacity: 0.7,
                                                            fontSize: '20px',
                                                        }),
                                                        input: (provided) => ({
                                                            ...provided,
                                                            fontSize: '20px',
                                                            fontWeight: '300',
                                                            margin: 0,
                                                            padding: 0,
                                                        }),
                                                        valueContainer: (provided) => ({
                                                            ...provided,
                                                            padding: 0,
                                                        }),
                                                    },
                                                }}
                                                autocompletionRequest={{
                                                    bounds: [
                                                        {lat: 50, lng: 50},
                                                        {lat: 100, lng: 100}
                                                    ],
                                                    types: ["address"],
                                                    componentRestrictions: {
                                                        country: ['us'],
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Address Section - Merged fields - Continue grey background */}
                            <div className="row">
                                <div className="col-md-12">
                                    <label className="form-label" style={{fontSize: '16px', fontWeight: '400', color: '#414042', marginBottom: '12px'}}>
                                        Address*
                                    </label>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="form-outline">
                                        <input className="form-control my-text-field"
                                               placeholder={"Address line 1*"} {...register("addressLineOne", registerOptions.addressLineOne)} />
                                        <small className="text-danger">
                                            {errors?.addressLineOne && errors.addressLineOne.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="form-outline">
                                        <input className="form-control my-text-field"
                                               placeholder={"Address line 2"}
                                               {...register("addressLineTwo", registerOptions.addressLineTwo)} />
                                        <small className="text-danger">
                                            {errors?.addressLineTwo && errors.addressLineTwo.message}
                                        </small>
                                    </div>
                                </div>
                                {/* City, State, Zipcode, Country on one line */}
                                <div className="col-sm-3 col-md-3 mb-3">
                                    <div className="form-outline">
                                        <input className="form-control my-text-field"
                                               placeholder={"City*"} {...register("city", registerOptions.city)} />
                                        <small className="text-danger">
                                            {errors?.city && errors.city.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 mb-3">
                                    <div className="form-outline">
                                        <select
                                            className="form-control my-select-field" {...register("state", registerOptions.state)}>
                                            <option value="">State*</option>
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District Of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </select>
                                        <small className="text-danger">
                                            {errors?.state && errors.state.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 mb-3">
                                    <div className="form-outline">
                                        <input
                                            className="form-control my-text-field" placeholder={"Zipcode*"}
                                            {...register("zipCode", registerOptions.zip)} />
                                        <small className="text-danger">
                                            {errors?.zipCode && errors.zipCode.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-3 mb-3">
                                    <div className="form-outline">
                                        <select
                                            className="form-control my-select-field" {...register("country", registerOptions.country)}>
                                            <option value="">Country*</option>
                                            <option value="US">USA</option>
                                        </select>
                                        <small className="text-danger">
                                            {errors?.country && errors.country.message}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Info Section - Continue grey background */}
                            <div className="row" style={{backgroundColor: '#f4f4f4', padding: '20px', borderRadius: '8px'}}>
                                <div className="col-md-12">
                                    <label className="form-label" style={{fontSize: '16px', fontWeight: '400', color: '#414042', marginBottom: '12px'}}>
                                        Contact Info
                                    </label>
                                </div>
                                <div className="col-sm-6 col-md-6 mb-3">
                                    <div className="form-outline">
                                        <Controller
                                            control={control}
                                            name="mobileNumber"
                                            rules={{
                                                required: {value: true, message: "Required"},
                                                minLength: {value: 11, message: "Enter a valid 10 digits USA phone"},
                                                maxLength: {value: 11, message: "Max Length"},
                                                validate: isNumber
                                            }}
                                            render={({field: {ref, ...field}}) => <PhoneInput
                                                {...field}
                                                inputExtraProps={{
                                                    ref,
                                                    required: true,
                                                }}
                                                country={'us'}
                                                onlyCountries={["us"]}
                                                countryCodeEditable={false}
                                                specialLabel={""}
                                            />}
                                        />
                                        <small className="text-danger">
                                            {errors?.mobileNumber && errors.mobileNumber.message}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6 mb-3">
                                    <div className="form-outline">
                                        <input
                                            className="form-control my-text-field"
                                            placeholder={"E-mail"}
                                            type="email"
                                            {...register("email", registerOptions.email)} />
                                        <small className="text-danger">
                                            {errors?.email && errors.email.message}
                                        </small>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Right Column - How did you hear about us */}
                    <div className="col-md-4">
                        <div className="how-did-you-hear" style={{fontSize: '16px', fontWeight: '400', color: '#414042', marginBottom: '20px'}}>
                            How did you hear about us?
                        </div>

                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="1"
                                   id="exampleRadios1" value="1" checked={howDoYouKnowUs === '1'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios1">
                                &nbsp;BrushPassResearch x Farelanes Social Content
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="3"
                                   id="exampleRadios3" value="3" checked={howDoYouKnowUs === '3'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios3">
                                &nbsp;Farelanes.com blog
                            </label>
                        </div>
                        <div className="form-check inline ">
                            <input className="form-check-input" type="checkbox" name="4"
                                   id="exampleRadios4" value="4" checked={howDoYouKnowUs === '4'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios4">
                                &nbsp;LinkedIn &nbsp; &nbsp;
                            </label>
                        </div>
                        <div className="form-check inline ">
                            <input className="form-check-input" type="checkbox" name="41"
                                   id="exampleRadios41" value="41" checked={howDoYouKnowUs === '41'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios41">
                                &nbsp;Facebook &nbsp; &nbsp;
                            </label>
                        </div>
                        <div className="form-check inline ">
                            <input className="form-check-input" type="checkbox" name="42"
                                   id="exampleRadios42" value="42" checked={howDoYouKnowUs === '42'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios42">&nbsp;Instagram</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="2"
                                   id="exampleRadios2" value="2" checked={howDoYouKnowUs === '2'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios2">
                                &nbsp;Google / Search Engine
                            </label>
                        </div>
                        <div className="form-check inline">
                            <input className="form-check-input" type="checkbox" name="51"
                                   id="exampleRadios51" value="51" checked={howDoYouKnowUs === '51'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios51">
                                &nbsp;BCS &nbsp; &nbsp;
                            </label>
                        </div>
                        <div className="form-check inline">
                            <input className="form-check-input" type="checkbox" name="52"
                                   id="exampleRadios52" value="52" checked={howDoYouKnowUs === '52'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios52">
                                &nbsp;IFA &nbsp; &nbsp;
                            </label>
                        </div>
                        <div className="form-check inline">
                            <input className="form-check-input" type="checkbox" name="53"
                                   id="exampleRadios53" value="53" checked={howDoYouKnowUs === '53'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios53">
                                &nbsp;TIA &nbsp; &nbsp;
                            </label>
                        </div>
                        <div className="form-check inline">
                            <input className="form-check-input" type="checkbox" name="5"
                                   id="exampleRadios5" value="5" checked={howDoYouKnowUs === '5'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios5">
                                &nbsp;Other trade show
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="6"
                                   id="exampleRadios6" value="6" checked={howDoYouKnowUs === '6'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios6">
                                &nbsp;Word of Mouth
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="7"
                                   id="exampleRadios7" value="7" checked={howDoYouKnowUs === '7'}
                                   onChange={onOptionChange}/>
                            <label className="form-check-label" htmlFor="exampleRadios7">
                                &nbsp;Other
                            </label>
                        </div>
                    </div>
                </div>

                {/* Save Button - Continue grey background */}
                <div className="row" style={{backgroundColor: '#f4f4f4', padding: '20px', borderRadius: '8px', marginTop: '20px'}}>
                    <div className="col-12 text-center">
                        <input
                            className="button__settings-save"
                            type="submit"
                            value="SAVE & CONTINUE"
                            style={{
                                backgroundColor: '#FFB84D',
                                color: '#fff',
                                border: 'none',
                                padding: '12px 48px',
                                fontSize: '16px',
                                fontWeight: '600',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                minWidth: '260px',
                                maxWidth: '100%',
                                whiteSpace: 'nowrap',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        />
                    </div>
                </div>
                {/*</div>*/}


            </form>
        }

        {(!farelanesUser || !state.showResult) &&
            <PageLoader />
        }

    </section>;
};

export default withAuthenticationRequired(ProfileDetails, {
    onRedirecting: () => <Loading/>,
});
